import { useMutation } from "react-query";
import { logout } from "@/api";
import { AxiosError } from "axios";

export const useLogout = () => {
  return useMutation<unknown, AxiosError, { user_id: string }>(
    async ({ user_id }) => {
      await logout({ user_id });
    },
  );
};
